import { createHumps } from 'lodash-humps-ts';
import { snakeCase, isArray, isObject, isEmpty } from 'lodash';

export const snakes: (node: object) => Record<string, string> = createHumps(snakeCase);
export const isEmptyArray = <T>(source: T) => isArray(source) && isEmpty(source);
export const isObjectOnly = <T>(source: T) => isObject(source) && !isArray(source);
